export default __webpack_public_path__ + "static/media/raffle_holiday___sneakers_p.bed131a9.png";